<template>
  <b-badge v-if="order" :variant="variant">
    {{ status | titleize }}
  </b-badge>
  <b-badge v-else>
    <i class="fa fas fa-spin fa-spinner"></i>
  </b-badge>
</template>

<script>
import Constants from '../../../constants';
import BridgeService from '../../services/bridge';
import orderMerge from '../../services/orderMerge'

export default {
  name: 'CondensedStatus',
  data() {
    return {
      order: null,
    }
  },
  props: {
    number: { type: String, required: true },
    knownOrder: { type: Object, default: () => undefined },
  },
  mounted() {
    if (this.knownOrder) {
      this.order = this.knownOrder
    } else {
      this.fetchOrder()
    }
  },
  methods: {
    fetchOrder() {
      if (!this.order) {
        BridgeService.getSalesOrder(this.number).then((r) => {
          this.order = r.data.merged;
        });
      }
    },
  },
  computed: {
    status() {
      if (!this.order) {
        return null;
      }
      return this.order.status.fishbowl || this.order.status.shopify;
    },
    variant() {
      switch (this.status) {
        case 'authorized':
        case 'pending':
        case 'null':
        case 'unfulfilled':
        case 'invoice_sent':
          return 'secondary';
        case 'partially_packing':
        case 'partially_packed':
        case 'picking':
        case 'packing':
        case 'picking_and_packing':
        case 'picking_and_packed':
          return 'primary';
        case 'partially_paid':
        case 'partial':
        case 'open':
        case 'to_be_imported':
        case 'to_be_issued':
          return 'info';
        case 'picking_backordered':
        case 'packing_backordered':
        case 'partially_backordered':
          return 'dark';
        case 'refunded':
        case 'partially_refunded':
        case 'restocked':
        case 'voided':
        case 'expired':
        case 'canceled':
          return 'danger';
        case 'charged':
        case 'shipped':
        case 'partially_shipped':
        case 'charged_and_partially_shipped':
        case 'closed_short':
        case 'quote':
          return 'warning';
        case 'paid':
        case 'fulfilled':
        case 'completed':
        case 'issued':
        case 'partially_shipping_today':
        case 'shipping_today':
        case 'fulfilled_and_shipped':
          return 'success';
        default:
          return 'dark';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utility/CondensedStatus.vue